import { render, staticRenderFns } from "./ProvinceCityList.vue?vue&type=template&id=8f0f7908"
import script from "./ProvinceCityList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProvinceCityList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports